import { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import chevron from 'assets/common/icons/chevron-right.svg';

interface ReadMoreProps {
  text: string;
  lineHeight?: number;
  lines?: number;
}

export const ReadMore: React.FC<ReadMoreProps> = ({ text, lineHeight = 24, lines = 2 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [text]);

  const collapsedHeight = lineHeight * lines;

  return (
    <div>
      <motion.div
        style={{ overflow: 'hidden', lineHeight: `${lineHeight}px` }}
        animate={{ height: isExpanded ? contentHeight : collapsedHeight }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      >
        <div
          ref={contentRef}
          style={{
            display: '-webkit-box',
            WebkitLineClamp: isExpanded ? 'unset' : lines,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {text}
        </div>
      </motion.div>

      <motion.div
        style={{
          marginTop: '32px',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '16px',
          userSelect: 'none',
        }}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <span>{isExpanded ? 'Read less' : 'Read more'}</span>
        <motion.img
          src={chevron}
          alt=""
          style={{ width: '8px', height: '12px' }}
          animate={{ rotate: isExpanded ? -90 : 90 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      </motion.div>
    </div>
  );
};
